import { AbstractModel } from "@gipi-pages/abstract/models/abstract.model";
import { ClientClassificationModel } from "@gipi-pages/client-classification/models/client-classification.model";

export class NotificationClientFilterClientClassification extends AbstractModel {

    /** @Required */
    classification: ClientClassificationModel;

}
